import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative" data-id="element-188">
      <div className="max-w-4xl mx-auto text-center" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-190">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-espresso leading-tight mb-8" data-id="element-191">
            "¿Sabías que las galletas rellenas y el hojaldre artesanal son los
            productos con{' '}
            <span className="text-caramel italic" data-id="element-192">
              mayor margen de ganancia
            </span>{' '}
            en la repostería actual?"
          </h2>

          <div className="w-24 h-1 bg-caramel mx-auto mb-8 rounded-full" data-id="element-193"></div>

          <p className="text-xl md:text-2xl text-espresso-light font-sans max-w-3xl mx-auto leading-relaxed" data-id="element-194">
            No necesitas máquinas caras ni un local físico. Solo necesitas las
            recetas correctas y un método probado.
          </p>
        </motion.div>

        {/* Variety grid — más sabores que puedes vender */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-12 max-w-4xl mx-auto" data-id="element-195">
          {[{
          src: 'https://cdn.magicpatterns.com/uploads/osB9b9cJfF6jvMuzxY34nK/Imagen_de_Galletas.webp',
          alt: 'Galletas de chocolate blanco con arándanos'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/w8fzkuvZ3t8DkHRzxxMcXh/imagen_galletas_2.webp',
          alt: 'Galletas rellenas de Nutella y chocolate'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/muzLQ3PtLU24Ms85E6Wf69/imagen_galletas_3.webp',
          alt: 'Galletas Red Velvet con glaseado de queso crema'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/4mkhXG35DTFRSt7Rcgbu8T/imagen_galletas_4.webp',
          alt: 'Galletas estilo brownie'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/e4n6oDGDfD1bWw5qVTHwXb/imagen_galletas_5.webp',
          alt: 'Galletas Red Velvet con chips de chocolate'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/7jQSuwbwfek2p3H2N7x3MM/imagen_galleta_6.webp',
          alt: 'Galleta Tiramisú crumble'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/a2Ae7gJruegUxUTzAKfL3T/imagen_galleta_7.webp',
          alt: 'Galleta pastel de confeti'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/1VQhs3MTeYrwwzd9bZvPrs/imagen_galleta_8.webp',
          alt: 'Galletas de pistacho con chocolate blanco'
        }].map((img, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.92
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1 + i % 4 * 0.08
        }} className="rounded-2xl overflow-hidden shadow-soft border-2 border-white" data-id="element-196">
              <img src={img.src} alt={img.alt} width={1080} height={1080} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-197" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}